import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-toyota',
  templateUrl: './toyota.component.html',
  styleUrls: ['./toyota.component.scss']
})


export class ToyotaComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['toyota-video'];
  }

}
